import type { SphereId } from '@superposition/domain';

/** цвет сферы на колесе и ползунках: внутренние — чёрные, внешние — красные */
const WHEEL: Record<SphereId, string> = {
  sostoyanie: 'var(--s-sostoyanie)',
  zdorovie: 'var(--s-zdorovie)',
  otnosheniya: 'var(--s-otnosheniya)',
  prostranstvo: 'var(--s-prostranstvo)',
  dengi: 'var(--s-dengi)',
  produkt: 'var(--s-produkt)',
  vliyanie: 'var(--s-vliyanie)',
  realizatsiya: 'var(--s-realizatsiya)',
};

/** палитра матрицы: у каждой сферы свой цвет. c — заливка, t — текст на белом */
export const MX: Record<SphereId, { c: string; t: string }> = {
  sostoyanie: { c: '#e01f26', t: '#e01f26' }, // красный
  zdorovie: { c: '#f4c20d', t: '#a67a00' }, // жёлтый
  otnosheniya: { c: '#8f1319', t: '#8f1319' }, // бордовый
  prostranstvo: { c: '#8a8a84', t: '#6b6b6b' }, // серый
  dengi: { c: '#ef7d1a', t: '#c65e08' }, // оранжевый
  produkt: { c: '#e0a010', t: '#a67400' }, // янтарно-золотой
  vliyanie: { c: '#1a1a1a', t: '#1a1a1a' }, // чёрный
  realizatsiya: { c: '#c0472a', t: '#b03d20' }, // ржаво-красный
};

export function sphereColor(id: SphereId): string {
  return WHEEL[id];
}

export function matrixColor(id: SphereId): { c: string; t: string } {
  return MX[id];
}
